import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { Subject } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { LoggerService } from "./logger.service";
import { AppConfig } from "../../../config/app.config";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { throwError } from "rxjs";
import * as moment from "moment";

@Injectable()
export class HttpclientService {
	public remoteServiceName: any;

	constructor(private http: HttpClient, private config: AppConfig, private userService: UserService, private loggerService: LoggerService) {
		this.remoteServiceName = this.config.getConfig("host");
	}

	createAuthorizationHeader() {
		var user: any = this.userService.getCurrentUser();
		let promise = new Promise((resolve, reject) => {
			if (user) {
				var isafter = false;
				var now: Date = new Date();
				var expireDT: Date = new Date(user.token_expiration);
				isafter = now > expireDT;

				if (isafter) {
					this.userService.setCurrentUser(null);
					resolve(null); // ? Needs to be looked at to see if there is a issue here!

					// var refreshToken$ = this.refreshToken();

					// refreshToken$.subscribe(
					// 	(res) => {
					// 		resolve(res);
					// 	},
					// 	(errorrefreshToken) => {
					// 		reject(errorrefreshToken);
					// 	}
					// );
				} else {
					resolve(user.token);
				}
			} else {
				resolve(null); // ? Needs to be looked at to see if there is a issue here!
			}
		});

		return promise;
	}

	postParralle(postedurl, data, Bearer) {
		var url = this.remoteServiceName + postedurl;
		var httpOptions: any;
		httpOptions = {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			}),
		};

		httpOptions.headers = httpOptions.headers.set("Authorization", "Bearer " + Bearer);

		return this.http.post(url, data, httpOptions);
	}

	post(postedurl, data) {
		var url = this.remoteServiceName + postedurl;

		var httpOptions: any;
		httpOptions = {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			}),
		};

		var postResult$ = new Subject();

		var current$ = this.createAuthorizationHeader();
		current$.then((res) => {
			if (res) {
				httpOptions.headers = httpOptions.headers.set("Authorization", "Bearer " + res);
				//httpOptions.headers.append('Authorization', 'Bearer ' + res);
			}

			var result = this.http
				.post(url, data, httpOptions)
				.pipe(
					map((response: any) => {
						let r = response;
						return r;
					})
				)
				.pipe(
					catchError((error: any): any => {
						postResult$.error("Fatal Error. Please contact the support");
						return throwError(error.error || "Server error");
					})
				);

			result.subscribe(
				(data) => {
					if (data.error) {
						postResult$.error(data.error.Message);
					} else {
						if (data.result != undefined) {
							postResult$.next(data.result);
						} else {
							postResult$.next(data);
						}
					}
				},
				(error) => {
					var erroMessage;

					if (error.status == "400") {
						postResult$.error(error._body);
					} else if (error._body) {
						if (!this.IsJsonString(error._body)) {
							postResult$.error("Fatal Error. Please contact the support");
						} else {
							var body = JSON.parse(error._body);
							var errorMessage = JSON.parse(body.error_description);
							postResult$.error(errorMessage);
						}
					} else {
						//this.loggerService.logError(error["message"])
					}
				}
			);
		});

		return postResult$;
	}

	postBlob(postedurl, data) {
		var url = this.remoteServiceName + postedurl;

		var httpOptions: any;
		httpOptions = {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
			}),
			responseType: "blob",
		};

		var postResult$ = new Subject();

		var current$ = this.createAuthorizationHeader();
		current$.then((res) => {
			if (res) {
				httpOptions.headers = httpOptions.headers.set("Authorization", "Bearer " + res);
			}

			var result = this.http.post(url, data, httpOptions);
			result.subscribe(
				(data: any) => {
					console.log("data");
					console.log(data);
					postResult$.next(data);
				},
				(error: any) => {
					console.log("error");
					console.log(error);
					postResult$.error("Fatal Error. Please contact the support");
				}
			);
		});

		return postResult$;
	}

	getSoundFile(postedurl, data) {
		var url = this.remoteServiceName + postedurl;

		var httpOptions: any;
		httpOptions = {
			headers: new HttpHeaders({
				//'Content-Type': 'audio/mpeg',
				"Content-Type": "application/json",
			}),
		};

		var postResult$ = new Subject();

		var current$ = this.createAuthorizationHeader();
		current$.then((res) => {
			if (res) {
				httpOptions.headers = httpOptions.headers.set("Authorization", "Bearer " + res);
				//httpOptions.headers.append('Authorization', 'Bearer ' + res);
			}

			var result = this.http
				.post(url, data, httpOptions)
				.pipe(
					map((response: any) => {
						let r = response;
						return r;
					})
				)
				.pipe(
					catchError((error: any): any => {
						postResult$.error("Fatal Error. Please contact the support");
						return; //Observable.throw(error.error || 'Server error');
					})
				);

			result.subscribe(
				(data) => {
					if (data.error) {
						postResult$.error(data.error.Message);
					} else {
						if (data.result != undefined) {
							postResult$.next(data.result);
						} else {
							postResult$.next(data);
						}
					}
				},
				(error) => {
					var erroMessage;

					if (error.status == "400") {
						console.log("Error 400");
						postResult$.error(error._body);
					} else if (error._body) {
						console.log("Error != 400. Error._body");

						//Not expecting JSON

						// if (!this.IsJsonString(error._body)) {
						//   postResult$.error("Fatal Error. Please contact the support");
						// } else {
						//   var body = JSON.parse(error._body);
						//   var errorMessage = JSON.parse(body.error_description);
						//   postResult$.error(errorMessage);
						// }
					} else {
						console.log("Error != 400 and Error != Body");
						console.log(error["message"]);
						console.log("Data " + data);

						//this.loggerService.logError(error["message"])
					}
				}
			);
		});

		return postResult$;
	}

	private refreshToken() {
		var postResult$ = new Subject();
		var user = this.userService.getCurrentUser();

		if (user == null || !user.refresh_token) {
			postResult$.error("Cannot refresh Token");
			return postResult$;
		}
		var param = {
			refresh_token: user.refresh_token,
			grant_type: "refresh_token",
		};

		const httpOptions = {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				Authorization: "Bearer " + user.token,
			}),
		};

		var url = this.remoteServiceName + "api/token/auth";
		var result = this.http.post(url, param, httpOptions).pipe(
			map((response: any) => {
				let r = response;
				return r;
			})
		);

		result.subscribe(
			(data) => {
				if (data.error) {
					postResult$.error(data.error.Message);
				} else {
					var response;
					if (data.result != undefined) {
						response = data.result;
					} else {
						response = data;
					}
					var thisResponse: any = response;
					user.c_date = moment(new Date()).format("MM/DD/YYYY");
					user.isLoggedIn = true;
					user.token = thisResponse.access_token;
					user.refresh_token = thisResponse.refresh_token;
					user.token_expiration = thisResponse.expiration;
					this.userService.setCurrentUser(user);
					postResult$.next(user.token);
				}
			},
			(error) => {
				var erroMessage;
				if (error.status == "400") {
					postResult$.error(error._body);
				} else if (error._body) {
					if (!this.IsJsonString(error._body)) {
						postResult$.error("Fatal Error. Please contact the support");
					} else {
						var body = JSON.parse(error._body);
						var errorMessage = JSON.parse(body.error_description);
						postResult$.error(errorMessage);
					}
				} else {
					// postResult$.error(error["message"]);
					//this.loggerService.logError(error["message"])
					postResult$.error("Fatal Error. Please contact the support");
				}
			}
		);

		return postResult$;
	}

	private IsJsonString(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}
}
